export const actionPanels = {
	title: {
		home: 'Home',
		island: 'Islands',
		crm: 'HubSpot',
		slack: 'Slack',
		navigation: 'Navigation'
	},
	tooltip: {
	},
	message: {
	}
};
